<template>
	<div>
		<CommonHeader :setOrden="true" :showBackButton="true" :showIcon="true" :title="$t('myAccount')"></CommonHeader>
		<div class="header-content">
			<img :src="getImage()" />
			<div class="header-menu">
				<p>{{ $t('hi') }}, {{ user.name }}</p>
				<div @click="goToPersonalInfo()">
					<p>{{ $t('editPersonalData') }}</p>
					<span>&#8250;</span>
				</div>
			</div>
		</div>
		<div class="menu">
			<div @click="goToRestaurant()">
				<img height="18" width="18" src="~@/assets/icons/Restaurant.svg" />
				<p>{{ $t('Restaurantes') }}</p>
			</div>
			<div @click="goToFavorites()">
				<img height="18" width="18" src="~@/assets/icons/Favs.svg" />
				<p>{{ $t('Favs') }}</p>
			</div>
			<div @click="goToBilling()">
				<img height="18" width="18" src="~@/assets/icons/icon-facturacion.svg" />
				<p>{{ $t('billing') }}</p>
			</div>
			<div @click="goToHelp()">
				<img height="18" width="18" src="~@/assets/icons/icon-ayuda.svg" />
				<p>{{ $t('help') }}</p>
			</div>
		</div>
		<div class="content-cerrar">
			<img height="18" width="18" src="~@/assets/icons/icon-cerrarSesion.svg" @click="logOut" />
			<p @click="logOut">{{ $t('signOut') }}</p>
		</div>
	</div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import CommonHeader from '@/components/CommonHeader.vue'
import auth from '@/config/auth'
@Component({
	components: {
		CommonHeader
	}
})
export default class Profile extends Vue {
	user = this.$store.state.user

	goToRestaurant() {
		this.$router.push('/')
	}
	goToFavorites() {
		this.$router.push('/Favorites')
	}
	goToPersonalInfo() {
		this.$router.push('/personalinfo')
	}

	goToMyShipping() {
		this.$router.push('/myshopping')
	}

	goToDirections() {
		this.$router.push('/directions')
	}

	goToBilling() {
		this.$router.push('/invoiceregister')
	}

	goToHelp() {
		this.$router.push('/help')
	}

	getImage() {
		const user = auth.currentUser
		if (user != null) {
			return user.photoURL
		}
	}

	async logOut() {
		auth.signOut()
		await this.$store.dispatch('login', null)
		if (!this.$store.state.user) this.$router.push('/login')
	}
}
</script>
<style lang="scss" scoped>
p {
	margin: 0;
}
.header-content {
	padding: 1em;
	border: 1px solid #dadada;
	img {
		width: 81px;
		height: 81px;
		border-radius: 150px;
		background-image: url('~@/assets/img/beebot.png');
		background-size: cover;
		background-repeat: no-repeat;
	}
	.header-menu {
		display: inline-block;
		padding: 1em;
		width: 65%;
		p {
			color: rgba(254, 202, 56, 1);
			font-weight: 700;
			font-size: 1.8em;
		}
		div {
			display: flex;
			justify-content: space-between;
			align-items: baseline;
			width: 80%;
			p {
				font-size: 1.1em;
				color: rgba(117, 112, 112, 1);
			}
			span {
				font-weight: 400;
				font-size: 1.5em;
				color: rgba(117, 112, 112, 1);
			}
		}
	}
}
.menu {
	padding: 1em;
	div {
		margin: 1em 0;
		img {
			display: inline-block;
		}
		p {
			display: inline-block;
			margin-left: 0.3em;
			color: rgba(117, 112, 112, 1);
			font-size: 1em;
			font-weight: 400;
			line-height: 24px;
		}
	}
}

.content-cerrar {
	padding: 2em 1em;
	border: 1px solid #dadada;
	position: absolute;
	bottom: 0px;
	width: 100%;
	font-size: 1em;
	color: rgba(117, 112, 112, 1);
	p {
		display: inline-block;
		margin-inline: 0.5em;
		color: rgba(117, 112, 112, 1);
		font-size: 1em;
		font-weight: 400;
		line-height: 24px;
	}
}
</style>
